import React, {Component, Fragment} from "react";
import UserHeader from "./UserHeader";
import UserResultFilter from "./UserResultFilter";
import {connect} from "react-redux";
import Loading from "../../components/Loading";
import MomentDate from "../../components/MomentDate";
import _ from "lodash";
import EventHelper from "../../helpers/EventHelper";
import ReactDOM from "react-dom";
import BetCheck from "./History/BetCheck";
import Xhr from "../../helpers/Xhr";
import {LOCAL} from "../../constants/local";

class UserBetHistory extends Component {
	state = {
		sports   : [],
		fetching : true
	};

	componentWillMount() {
		Xhr.getSports().then((resp) => {
			this.setState({
				sports   : resp.data.sports,
				fetching : false
			});
		});
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (nextProps.bet.history !== this.props.bet.history) || (nextState.sports !== this.state.sports);
	}

	getInfo(bet, events) {
		const params = "menubar=no,location=yes,resizable=no,scrollbars=no,status=no,width=850,height=420";
		const myWindow = window.open("about:blank", "Чек", params);
		myWindow.onload = () => {
			const div = myWindow.document.createElement('div'),
				body = myWindow.document.body;

			ReactDOM.render(<BetCheck bet={bet}
			                          events={events}/>, div);
			body.insertBefore(div, body.firstChild);
		};
	}

	render() {
		const {bet, user} = this.props;
		const {sports} = this.state;

		if ( this.state.fetching ) {
			return <Loading/>;
		}

		const {bets, events, leagues} = bet.history;
		const sortedBets = _.sortBy(bets, i => i.number).reverse();

		const all_bets = sortedBets.map((bet) => {
			const {details} = bet;
			const sortedDetails = _.sortBy(details, i => i.event_time);
			const dt = sortedDetails.map((detail) => {
				const event = _.first(events.filter((event) => {return parseInt(event.id) === detail.event_id}));
				const league = _.first(leagues.filter((league) => {return parseInt(league.id) === detail.league_id}))
				const sport = _.find(sports, (s) => {return s.id === event.sport_id});

				const statusColors = {
					0 : 'cl-gray',
					1 : 'cl-red',
					2 : 'cl-blue'
				};

				const statusColor = statusColors.hasOwnProperty(detail.status) ? statusColors[detail.status] : 'cl-gray';

				return (
					<Fragment>
						<tr className="bet-history__item-data">
							<td className="time"><MomentDate date={detail.event_time} isFormatDate={true}/></td>
							<td className="event">
								{parseInt(event.type) === 1 && <span className="cl-red">Live.&nbsp;</span>}
								<span>{sport.name}.</span>
								<span>&nbsp;{league.name}</span>
								<span>&nbsp;{EventHelper.parseTeams(event.team1, event.team2)}:</span>
								<strong>&nbsp;{detail.bet_name}</strong>
							</td>
							<td className="koeff">
								<span className={`${statusColor}`}>{detail.value}</span>
							</td>
							<td className="result">
								{detail.result !== null && detail.result}&nbsp;
							</td>
							{/*<td className="check">&nbsp;</td>*/}
						</tr>
					</Fragment>
				);
			});

			return (
				<Fragment>
					<tbody className="bet-history__item">
						<tr className="bet-history__item-header">
							<td colSpan={2} className="bet-data">
								<div>
									Ст.&nbsp;№{bet.number}&nbsp;(<MomentDate date={bet.ts} isFormatDate={true}/>)
									Сумма:&nbsp;
									<strong style={{color : '#000'}}>{bet.amount}&nbsp;{user.info.currency}</strong>&nbsp;
									{bet.type}&nbsp;
									<span style={{color : '#000'}}>{bet.count_bets > 1 && `(K=${bet.value.toFixed(2)})`}</span>
								</div>
								<div>
									<span>Возможный выигрыш: <span style={{color : '#000'}}>{(bet.amount * +bet.value).toFixed(2)} {LOCAL.currency}</span></span>
								</div>
							</td>
							<td className="koeff">&nbsp;</td>
							<td className="result">
								{bet.isVip && bet.hasOwnProperty('status_vip') && bet.status_vip}
								{bet.win !== 0 && `${bet.win} ${user.info.currency}`}&nbsp;
							</td>
							{/*<td className="check">*/}
								{/*<span onClick={this.getInfo.bind(this, bet, events)}>*/}
									{/*<i className="fas fa-print"></i>*/}
								{/*</span>*/}
							{/*</td>*/}
						</tr>

						{dt}
					</tbody>
				</Fragment>
			);
		});

		return (
			<Fragment>
				<UserHeader text={'История ставок'}/>
				<UserResultFilter/>

				{this.props.bet.fetching && <Loading/>}

				<div className="bet-history">
					<table>
						<thead>
							<tr>
								<th className="time">Время</th>
								<th className="event">Событие</th>
								<th className="koeff">К</th>
								<th className="result">Результат</th>
								{/*<th className="check">Чек</th>*/}
							</tr>
						</thead>

						{all_bets}
					</table>
				</div>
			</Fragment>
		);
	}
}

export default connect(
	state => ({
		bet  : state.bet,
		user : state.user
	})
)(UserBetHistory);


// WEBPACK FOOTER //
// ./src/app/pages/User/UserBetHistory.js